import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import NavItems3 from "../NavItems3";
import NavItems2 from "../NavItems2";
import "./MeasuringForm.css";

function MeasuringForm(props) {
  const {
    ellipse116,
    x1200PxLogo_Icam__20081,
    criteriaMeasurementForm,
    environnementCriteria1,
    environnementCriteria2,
    x4LeadTimeCriteria,
    x2SocialCriteria,
    x5CostCriteria,
    x3ModernizationCriteria,
    x6QualityCriteria,
    navItems3Props,
  } = props;

  // State to track the completion status of each section
  const [completionStatus, setCompletionStatus] = useState({
    environmental: false,
    social: false,
    modernization: false,
    leadTime: false,
    cost: false,
    quality: false,
    clientConsommateur: false
  });

  // Simulate retrieving status from an API or localStorage
  useEffect(() => {
    const fetchStatusData = () => {
      const storedStatus = localStorage.getItem('criteriaCompletionStatus');
      if (storedStatus) {
        setCompletionStatus(JSON.parse(storedStatus));
      }
    };
    fetchStatusData();
  }, []);

  // Save status to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('criteriaCompletionStatus', JSON.stringify(completionStatus));
  }, [completionStatus]);

  // Define criteria with their links and status keys
  const criteria = [
    { name: environnementCriteria1 || "Environmental Criteria", path: "/environmental-1", icon: "🌿", statusKey: "environmental" },
    { name: x2SocialCriteria || "Social Criteria", path: "/social-1", icon: "👥", statusKey: "social" },
    { name: x3ModernizationCriteria || "Modernization Criteria", path: "/modernization-1", icon: "🔄", statusKey: "modernization" },
    { name: x4LeadTimeCriteria || "Lead Time Criteria", path: "/lead-time-1", icon: "⏱️", statusKey: "leadTime" },
    { name: x5CostCriteria || "Cost Criteria", path: "/cost-1", icon: "💰", statusKey: "cost" },
    { name: x6QualityCriteria || "Quality Criteria", path: "/quality-1", icon: "✅", statusKey: "quality" },
    { name: "Client Consumer", path: "/client-consommateur-1", icon: "👨‍👩‍👧‍👦", statusKey: "clientConsommateur" },
  ];

  // Handle form submission
  const submitForm = () => {
    const allCompleted = Object.values(completionStatus).every(status => status === true);

    if (allCompleted) {
      alert("Form submitted successfully!");
      window.location.href = "/functional-view-1";
    } else {
      alert("Please complete all sections before submitting the form.");
    }
  };

  // Update the status of a section (used when a section is completed)
  const updateSectionStatus = (statusKey, isCompleted) => {
    setCompletionStatus(prevStatus => ({
      ...prevStatus,
      [statusKey]: isCompleted
    }));
  };

  return (
    <div className="measuring-form-container">
      <div className="measuring-form-content">
        <h1 className="measuring-form-title">
          {criteriaMeasurementForm || "CRITERIA MEASUREMENT FORM"}
        </h1>

        <p className="measuring-form-description">
          Please select a criterion to evaluate from the options below.
        </p>

        <div className="criteria-grid">
          {criteria.map((criterion, index) => (
            <Link
              to={criterion.path}
              key={index}
              className={`criterion-card ${completionStatus[criterion.statusKey] ? 'completed' : 'incomplete'}`}
            >
              <div className="criterion-icon">{criterion.icon}</div>
              <h3 className="criterion-name">{criterion.name}</h3>
              <div className="status-indicator">
                <span className="status-dot"></span>
                <span className="status-text">
                  {completionStatus[criterion.statusKey] ? "Completed" : "To be completed"}
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="form-actions">
          <Link to="/acquisition" className="btn-secondary">
            Back to Company Information
          </Link>
          <button onClick={submitForm} className="btn-primary">
            Submit and Proceed to Analysis Models
          </button>
        </div>
      </div>
    </div>
  );
}

export default MeasuringForm;
